import { createSlice } from '@reduxjs/toolkit';

interface ApiState {
  api: any;
  headers: any;
}

const initialState: ApiState = {
  api: null,
  headers: {}
};

export const selectApi = (state: any) => state.api.api;

export const selectHeaders = (state: any) => state.api.headers;

export const apiSlice = createSlice({
  name: 'api',
  initialState,
  reducers: {
    setApi: (state, action) => {
        state.api = action.payload;
    },
    setHeaders: (state, action) => {
        state.headers = action.payload;
    }
  }
});

export default apiSlice.reducer;